import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQrCode01Filled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.00001 12C2.00001 11.4477 2.44772 11 3.00001 11H3.01001C3.56229 11 4.01001 11.4477 4.01001 12C4.01001 12.5523 3.56229 13 3.01001 13H3.00001C2.44772 13 2.00001 12.5523 2.00001 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.00001 17C7.00001 16.4477 7.44772 16 8.00001 16H8.01C8.56229 16 9.01 16.4477 9.01 17C9.01 17.5523 8.56229 18 8.01 18H8.00001C7.44772 18 7.00001 17.5523 7.00001 17Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11 21C11 20.4477 11.4477 20 12 20H12.01C12.5623 20 13.01 20.4477 13.01 21C13.01 21.5523 12.5623 22 12.01 22H12C11.4477 22 11 21.5523 11 21Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20 12C20 11.4477 20.4477 11 21 11H21.01C21.5623 11 22.01 11.4477 22.01 12C22.01 12.5523 21.5623 13 21.01 13H21C20.4477 13 20 12.5523 20 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.00001 17C2.00001 16.4477 2.44772 16 3.00001 16H4.50001C5.05229 16 5.50001 16.4477 5.50001 17C5.50001 17.5523 5.05229 18 4.50001 18H3.00001C2.44772 18 2.00001 17.5523 2.00001 17Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5 12C14.5 11.4477 14.9477 11 15.5 11H17.5C18.0523 11 18.5 11.4477 18.5 12C18.5 12.5523 18.0523 13 17.5 13H15.5C14.9477 13 14.5 12.5523 14.5 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.00001 21C2.00001 20.4477 2.44772 20 3.00001 20H8.00001C8.55229 20 9.00001 20.4477 9.00001 21C9.00001 21.5523 8.55229 22 8.00001 22H3.00001C2.44772 22 2.00001 21.5523 2.00001 21Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 1C12.5523 1 13 1.44772 13 2V8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8V2C11 1.44772 11.4477 1 12 1Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.5681 15C17.5787 15 17.5894 15 17.6 15H19.4C19.4106 15 19.4213 15 19.4319 15C19.6843 15 19.9301 14.9999 20.1382 15.0169C20.3668 15.0356 20.6366 15.0797 20.908 15.218C21.2843 15.4097 21.5903 15.7157 21.782 16.092C21.9203 16.3634 21.9644 16.6332 21.9831 16.8618C22.0001 17.0699 22 17.3157 22 17.5681C22 17.5787 22 17.5894 22 17.6V19.4C22 19.4106 22 19.4213 22 19.4319C22 19.6843 22.0001 19.9301 21.9831 20.1382C21.9644 20.3668 21.9203 20.6366 21.782 20.908C21.5903 21.2843 21.2843 21.5903 20.908 21.782C20.6366 21.9203 20.3668 21.9644 20.1382 21.9831C19.9301 22.0001 19.6843 22 19.4319 22C19.4213 22 19.4106 22 19.4 22H17.6C17.5894 22 17.5787 22 17.5681 22C17.3157 22 17.0699 22.0001 16.8618 21.9831C16.6332 21.9644 16.3634 21.9203 16.092 21.782C15.7157 21.5903 15.4097 21.2843 15.218 20.908C15.0797 20.6366 15.0356 20.3668 15.017 20.1382C14.9999 19.9301 15 19.6843 15 19.4319C15 19.4213 15 19.4106 15 19.4V17.6C15 17.5894 15 17.5787 15 17.5681C15 17.3157 14.9999 17.0699 15.017 16.8618C15.0356 16.6332 15.0797 16.3634 15.218 16.092C15.4097 15.7157 15.7157 15.4097 16.092 15.218C16.3634 15.0797 16.6332 15.0356 16.8618 15.0169C17.0699 14.9999 17.3157 15 17.5681 15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.00001 12C6.00001 11.4477 6.44772 11 7.00001 11H12C12.5523 11 13 11.4477 13 12V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V13H7.00001C6.44772 13 6.00001 12.5523 6.00001 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.5681 2C17.5787 2 17.5894 2 17.6 2H19.4C19.4106 2 19.4213 2 19.4319 2C19.6843 1.99997 19.9301 1.99994 20.1382 2.01695C20.3668 2.03562 20.6366 2.07969 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C21.9203 3.36344 21.9644 3.63318 21.9831 3.86177C22.0001 4.06993 22 4.31572 22 4.5681C22 4.57872 22 4.58936 22 4.6V6.4C22 6.41064 22 6.42128 22 6.4319C22 6.68428 22.0001 6.93007 21.9831 7.13823C21.9644 7.36682 21.9203 7.63656 21.782 7.90798C21.5903 8.28431 21.2843 8.59027 20.908 8.78201C20.6366 8.92031 20.3668 8.96438 20.1382 8.98305C19.9301 9.00006 19.6843 9.00003 19.4319 9C19.4213 9 19.4106 9 19.4 9H17.6C17.5894 9 17.5787 9 17.5681 9C17.3157 9.00003 17.0699 9.00006 16.8618 8.98305C16.6332 8.96438 16.3634 8.92031 16.092 8.78201C15.7157 8.59027 15.4097 8.28431 15.218 7.90798C15.0797 7.63656 15.0356 7.36682 15.017 7.13823C14.9999 6.93007 15 6.68428 15 6.4319C15 6.42128 15 6.41064 15 6.4V4.6C15 4.58936 15 4.57872 15 4.5681C15 4.31572 14.9999 4.06993 15.017 3.86177C15.0356 3.63318 15.0797 3.36344 15.218 3.09202C15.4097 2.71569 15.7157 2.40973 16.092 2.21799C16.3634 2.07969 16.6332 2.03562 16.8618 2.01695C17.0699 1.99994 17.3157 1.99997 17.5681 2Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.56811 2C4.57873 2 4.58936 2 4.60001 2H6.40001C6.41065 2 6.42128 2 6.4319 2C6.68429 1.99997 6.93008 1.99994 7.13824 2.01695C7.36683 2.03562 7.63656 2.07969 7.90799 2.21799C8.28431 2.40973 8.59027 2.71569 8.78202 3.09202C8.92032 3.36344 8.96438 3.63318 8.98306 3.86177C9.00007 4.06993 9.00004 4.31572 9.00001 4.5681C9.00001 4.57872 9.00001 4.58936 9.00001 4.6V6.4C9.00001 6.41064 9.00001 6.42128 9.00001 6.4319C9.00004 6.68428 9.00007 6.93007 8.98306 7.13823C8.96438 7.36682 8.92032 7.63656 8.78202 7.90798C8.59027 8.28431 8.28431 8.59027 7.90799 8.78201C7.63656 8.92031 7.36683 8.96438 7.13824 8.98305C6.93008 9.00006 6.68429 9.00003 6.4319 9C6.42128 9 6.41065 9 6.40001 9H4.60001C4.58936 9 4.57873 9 4.56811 9C4.31572 9.00003 4.06993 9.00006 3.86178 8.98305C3.63318 8.96438 3.36345 8.92031 3.09202 8.78201C2.7157 8.59027 2.40974 8.28431 2.21799 7.90798C2.07969 7.63656 2.03563 7.36682 2.01695 7.13823C1.99994 6.93007 1.99997 6.68428 2 6.4319C2 6.42128 2.00001 6.41064 2.00001 6.4V4.6C2.00001 4.58936 2 4.57872 2 4.5681C1.99997 4.31572 1.99994 4.06993 2.01695 3.86177C2.03563 3.63318 2.07969 3.36344 2.21799 3.09202C2.40974 2.71569 2.7157 2.40973 3.09202 2.21799C3.36345 2.07969 3.63318 2.03562 3.86178 2.01695C4.06993 1.99994 4.31572 1.99997 4.56811 2Z",
			fill: "currentColor"
		})
	]
});
export default SvgQrCode01Filled;
